import initialState from './state.js'
import Vue from 'vue'
import cloneDeep from 'lodash/cloneDeep'

export default {
  RESET_MARIA_CAMPAIGN_MODULE(state) {
    Object.keys(initialState).forEach((key) => {
      state[key] = cloneDeep(initialState[key])
    })
  },
  SET_OMNI_CAMPAIGN(state, omniCampaign) {
    state.campaign = omniCampaign
  },
  SET_PREVIOUS_OFFER_SCHEDULES(state, offerSchedules) {
    state.previousOfferSchedules = offerSchedules.map((schedule) => schedule.offer_schedule?._id || schedule?.offer_schedule_id || schedule?._id)
  },
  SET_OMNI_CAMPAIGN_KEY(state, { payload, key }) {
    const keys = key.split('.')
    let target = state.campaign

    for (let i = 0; i < keys.length - 1; i++) {
      target = target[keys[i]]
    }

    Vue.set(target, keys[keys.length - 1], payload)
  },
  SET_SEARCHED_PRODUCTS(state, products) {
    state.searchedProducts = products
  },
  SET_IMPORTED_PRODUCTS(state, products) {
    state.importedProducts = products
  },
  SET_SEARCH_PRODUCTS_VALUE(state, search) {
    state.searchProductsValue = search
  },
  SET_OMNI_CAMPAIGN_LIMITER(state, value) {
    state.campaign.messages_dispatcher.budget.limiter = value
  },
  SET_OMNI_CAMPAIGN_BUDGET(state, { channel, value }) {
    state.campaign.messages_dispatcher.budget.channels[channel] = value
  },
  SET_DAYS_ON_OFFERS(state, daysOnOffers) {
    state.daysOnOffers = daysOnOffers
  },
  SET_LOADING_ACTION(state, value) {
    state.loadingAction = value
  },
  SET_CAMPAIGN_VARIABLES_CONFIGURATION(state, payload) {
    state.campaignVariablesConfiguration = payload
  },
  SET_ID_CAMPAIGN_VARIABLES_CONFIGURATION(state, payload) {
    state.campaign.messages_dispatcher.settings.campaign_variable_configurations = [payload]
  },
  SET_MESSAGES_DISPATCHER_SETTINGS_CHANNEL(state, { scheduleSettingsId, channel, channelData }) {
    const scheduleSettingsIndex = state.campaign.messages_dispatcher.settings.schedule_settings.findIndex(
      (schedule_settings) => schedule_settings.id === scheduleSettingsId
    )
    if (scheduleSettingsIndex < 0) {
      throw new Error(`Schedule settings with id ${scheduleSettingsId} not found`)
    }
    state.campaign.messages_dispatcher.settings.schedule_settings[scheduleSettingsIndex].channels[channel] = channelData
  },
  SET_VARIABLE_CHAR_COUNT(state, { variable, charCount }) {
    if (!(variable in state.variablesCharCount)) {
      throw new Error(`Variável "${variable}" não existe no state`)
    }

    Vue.set(state.variablesCharCount, variable, charCount)
  },
  SET_BULK_VARIABLE_CHAR_COUNT(state, payload) {
    state.variablesCharCount = { ...state.variablesCharCount, ...payload }
  },
  SET_ALL_CHANNELS_CHAR_COUNT(state, payload) {
    state.channelsCharCount = payload
  },
  SET_ACTIVE_DISPATCH_PANEL(state, value) {
    state.activeDispatchPanel = value
  },
}
